export class BrokerRefreshError extends Error {
  constructor(
    readonly credentialInstanceId: string,
    readonly status: number,
  ) {
    super(`Credential ${credentialInstanceId}: broker refresh failed with status ${status}.`);
    this.name = "BrokerRefreshError";
  }
}
